import React, { useEffect, useState } from "react";
import AntdModal from "../../../components/common/AntdModal";
import { Divider, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import AppButton from "../../../components/common/AppButton";
import AppInput from "../../../components/common/AppInput";
import dayjs from "dayjs";
import usePrevious from "../../../components/hooks/usePrevious";
import usePayrollStore from "../../../config/stores/administration/usePayrollStore";
import axios from "axios";

const PayrollPeriodForm = () => {
  const payrollStore = usePayrollStore();
  const {
    showCreatePayrollPeriod,
    setCreatingPayrollPeriod,
    creatingPayrollPeriod,
    payrollPeriodCreated,
    getAllPayrolls,
    payrolls,
  } = payrollStore;
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const prevState = usePrevious({ payrollPeriodCreated });

  const closeModal = () => {
    payrollStore.setCreatingPayrollPeriod(false);
  };

  const onSubmit = async () => {
    try {
      const data = await form.validateFields();
      const payload = {
        month: data.month.month() + 1,
        year: data.year.year(),
        details: data.details || "",
      };

      setLoading(true);

      const res = await axios.post("/payroll/create-or-load", payload, {
        skipNotification: true,
      });
      
      const responseData = res?.data || res;
      const apiData = responseData?.data || responseData;
      const monthName = dayjs().month(payload.month - 1).format("MMMM");
      if (apiData.hasExistingData && apiData.payrollCount > 0) {
        message.warning(
          `Payroll time period already exists. Showing ${apiData.payrollCount} staff payroll entry/entries for this period.`,
          4
        );
      } else {
        message.success(
          `Payroll time period for ${monthName} ${payload.year} created successfully!`,
          4
        );
      }

      payrollStore.setPayrollPeriod(payload);
      payrollStore.setCreatingPayrollPeriod(false);
      
      setTimeout(() => {
        getAllPayrolls();
      }, 300);
    } catch (error) {
      const errorMsg = error?.response?.data?.message || error?.message || "Failed to create payroll period";
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const today = dayjs();

  useEffect(() => {
    if (
      prevState &&
      payrollPeriodCreated &&
      prevState.payrollPeriodCreated !== payrollPeriodCreated
    ) {
      form.resetFields();
    }
  }, [prevState, form, payrollPeriodCreated]);

  useEffect(() => {
    if (showCreatePayrollPeriod && creatingPayrollPeriod) {
      form.setFieldsValue({
        month: dayjs(),
        year: dayjs(),
        details: "",
      });
    }
  }, [showCreatePayrollPeriod, creatingPayrollPeriod, form]);

  return (
    <AntdModal
      title="CREATE PAYROLL TIME PERIOD"
      visible={showCreatePayrollPeriod}
      closeModal={closeModal}
      footer={[
        <AppButton
          text="CREATE TIME PERIOD"
          key={"create"}
          onClick={onSubmit}
          loading={loading}
        />,
        <AppButton text="CANCEL" key={"cancel"} onClick={closeModal} danger />,
      ]}
    >
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
        layout="horizontal"
        form={form}
      >
        <AppInput
          label="Month"
          name="month"
          type="date"
          inputAttributes={{
            picker: "month",
            disabledDate: (current) =>
              current && current < today.subtract(4, "month"),
            format: "MMMM",
          }}
          rules={[{ required: true }]}
        />
        <AppInput
          label="Year"
          name="year"
          type="date"
          inputAttributes={{
            picker: "year",
            disabledDate: (current) => {
              const year = current.year();
              return year < 2020 || year > 2030;
            },
          }}
          rules={[{ required: true }]}
        />
        <AppInput label="Details" name="details" type="textarea" />
      </Form>
      <Divider className="m-1" />
    </AntdModal>
  );
};

export default PayrollPeriodForm;
